export default __webpack_public_path__ + "static/media/ride-the-air.07686805.png";